import React, { useEffect, useState } from 'react';
import { getSkinsForComponent } from '../../skins/ComponentSkinLoader';
import { isSkinnableComponent } from '../../module/registry';
import ComponentSkinSelector from '../../skins/ComponentSkinSelector';

/**
 * 공통 스킨 선택 UI 컴포넌트
 * @param {Object} props
 * @param {Object} props.selectedComponent - 선택된 컴포넌트
 * @param {Function} props.onSkinChange - 스킨 변경 핸들러
 * @returns {JSX.Element|null}
 */
export const SkinSelector = ({ selectedComponent, onSkinChange }) => {
  const [availableSkins, setAvailableSkins] = useState([]);
  
  // 컴포넌트가 스킨을 지원하는지 확인하고 사용 가능한 스킨 로드
  useEffect(() => {
    if (selectedComponent && isSkinnableComponent(selectedComponent.type)) {

      // 내장 스킨 (basic)
      const skins = [
        { id: 'basic', name: '기본 스킨' }
      ];
      
      // 외부 스킨 추가
      const externalSkins = getSkinsForComponent(selectedComponent.type);
      skins.push(...externalSkins);
      
      setAvailableSkins(skins);
    }
  }, [selectedComponent]);
  
  // 스킨을 지원하지 않는 컴포넌트면 null 반환
  if (!selectedComponent || !isSkinnableComponent(selectedComponent.type)) {
    return null;
  }
  
  return (
    <div className="property-group">
      <div className="property-group-title">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 22V12M12 12L2 7M12 12l10-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        컴포넌트 스킨
      </div>
      <div className="property-control">
        <ComponentSkinSelector
          componentType={selectedComponent.type}
          selectedSkin={selectedComponent.componentProps?.skin || selectedComponent.props?.skin || 'basic'}
          onSkinChange={(skinId) => {
            onSkinChange(skinId);
          }}
          showPurchaseButton={true}
          style={{ width: '100%' }}
        />
      </div>
    </div>
  );
};

export default SkinSelector;